import { render, staticRenderFns } from "./IntegrationsPage.vue?vue&type=template&id=f712b42c&scoped=true&"
import script from "./IntegrationsPage.vue?vue&type=script&lang=js&"
export * from "./IntegrationsPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsPage.vue?vue&type=style&index=0&id=f712b42c&lang=scss&scoped=true&"
import style1 from "./IntegrationsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f712b42c",
  null
  
)

export default component.exports